import styled from "styled-components";

export const Component = styled.button`
  margin: 0px 7.5px;
  cursor: pointer;
  a {
    text-decoration: none;
    color: inherit;
  }
`;
